var render = function render(){var _vm=this,_c=_vm._self._c;return _c('InstallableDetailsBox',_vm._g(_vm._b({attrs:{"installable":_vm.selectedWorkflowInstallable}},'InstallableDetailsBox',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }